import { client } from 'src/enviroment/api/axios'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { Mutation, Query } from '../index'
import { handleApiError } from 'src/enviroment/api/errorHandler'
import { Dataset } from '../../types/dataset'

export const datasetRouterKeys = {
  datasets: 'dataset.datasets',
} as const

export const datasetRouter = {
  list: {
    useQuery: (params: { take?: number } = {}, opts?: Query<Dataset[]>) => {
      return useQuery<Dataset[]>({
        queryKey: [datasetRouterKeys.datasets],
        queryFn: async () => {
          return (await client.get<Dataset[]>('/datasets', { params })).data
        },
        ...opts,
      })
    },
  },
  create: {
    useMutation: (opts?: Mutation<string, Dataset>) => {
      const queryClient = useQueryClient()

      return useMutation({
        mutationFn: async (name: string) => {
          return (await client.post<Dataset>('/datasets', { name })).data
        },
        onSuccess: (...args) => {
          queryClient.invalidateQueries({ queryKey: [datasetRouterKeys.datasets] })
          opts?.onSuccess?.(...args)
        },
        onError: handleApiError,
        ...opts,
      })
    },
  },
  delete: {
    useMutation: (opts?: Mutation<string, void>) => {
      const queryClient = useQueryClient()

      return useMutation({
        mutationFn: async (datasetId: string) => {
          await client.delete(`/datasets/${datasetId}`)
        },
        onSuccess: (...args) => {
          queryClient.invalidateQueries({ queryKey: [datasetRouterKeys.datasets] })
          opts?.onSuccess?.(...args)
        },
        onError: handleApiError,
        ...opts,
      })
    },
  },
}
